export default __webpack_public_path__ + "static/media/garrett-full.8896f729.png";